import React, { useState, useEffect, useContext } from "react";
import { Container, Row, Col } from "reactstrap";
import {
  getAllBrokers,
  searchBrokerAPI,
} from "../stores/services/broker.service";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ReactTooltip from "react-tooltip";
import { useHistory } from "react-router-dom";
import {
  getFundByAmc,
  validateFundNav,
} from "../stores/services/funds.service";
import {
  getChartOfAccounts,
  getNewChartsOfAccounts,
  getNewChartsOfAccountsByFund,
} from "../stores/services/chatofaccounts.service";
import { getAllLedgers, getLedgerAccounts } from "../utils/customFunction";
import InputMask from "react-input-mask";

import { getDailyBankBalance } from "../stores/services/daily-expense.service";
import { getLedgerInfoByCode } from "../stores/services/chatofaccounts.service";
import moment from "moment";
import { addMegaTransaction } from "../stores/services/beta-transaction.service";
import { getNetAssets } from "../stores/services/daily-trustee-fee.service";
import { numberWithCommas } from "./../utils/customFunction";
import { ThemeContext } from "../contexts/ThemeContext";
import { useSelector } from "react-redux";
import Select from "react-select";
import { getNavDataForCalculation } from "../stores/services/nav.service";
import NumberFormat from "react-number-format";

interface FieldValues {
  email: any;
  txnr_type: any;
  amc_code: any;
  fund_code: any;
  instruction_date: any;
  execution_date: any;
  executed_date: any;
  fund_account: any;
  reinvest: any;
  account_title: any;
  period: any;
  account_no: any;
  bank: any;
  branch: any;
  counter_account_type: any;
  counter_type: any;
  counter_account_title: any;
  counter_account_number: any;
  counter_bank: any;
  counter_branch: any;
  mode_of_payment: any;
  payment_type: any;
  instrument_no: any;
  instrument_type: any;
  instrument_date: any;
  realized_date: any;
  realized: any;
  gross_amount: any;
  net_amount: any;
  dr_amount: any;
  cr_amount: any;
  balance: any;
  folio_no: any;
  unitholder_name: any;
  units: any;
  nav: any;
  dividend_date: any;
  dividend_rate: any;
  sale_date: any;
  current_holding: any;
  total_holding: any;
  symbol: any;
  dividend_percentage: any;
  credit_date: any;
  maturity_type: any;
  security_type: any;
  issue_date: any;
  conversion_date: any;
  associated_transaction: any;
  maturity_date: any;
  coupon_rate: any;
  price: any;
  face_value: any;
  money_market_face_value: any;
  detail: any;
  type: any;
  redemption_date: any;
  remain_holding: any;
  settlement_by: any;
  tax_type: any;
  settlement_date: any;
  total_charges: any;
  txn_charges: any;
  sale_txn_no: any;
  return_date: any;
  txn_id: any;
  tenor: any;
  yield: any;
  last_coupon_date: any;
  next_coupon_date: any;
  fund_ips_account: any;
  counter_party_ips_account: any;
  system_tax: any;
  primary_dealer: any;
  broker_commission: any;
  tax_sst: any;
  tax_wht_it: any;
  tax_wht_sst: any;
  tax_cgt: any;
  sale_load: any;
  redemption_load: any;
  low_balance_agree: any;
  offer_price: any;
  load_per_unit: any;
  percentage_of_discount: any;
  applicable_offer_price: any;
  sales_tax_collector: any;
  volume: any;
  par_value: any;
  announcement_date: any;
  bonus_percentage: any;
  bonus_credit_date: any;
  bonus_gross_volume: any;
  tax_it_bonus_amount: any;
  net_bonus_volume: any;
  right_share_percentage: any;
  right_share_credit_date: any;
  right_share_gross_volume: any;
  tax_it_right_share_amount: any;
  net_right_share_volume: any;
  tax_on_dvidend: any;
  tax_on_bonus: any;
  tax_on_right: any;
  zakat_amount: any;
  ledgers: any;
}

const ManagementFeeAccrual = (props: any) => {
  const theme = useSelector((state: any) => state.ThemeModeReducer.Theme);
  const history = useHistory();
  const context = useContext(ThemeContext);
  const email = sessionStorage.getItem("email") || "";
  const amc_name = sessionStorage.getItem("amc_name") || "";
  const amc_code = sessionStorage.getItem("amc_code") || "";
  const fund_code = JSON.parse(sessionStorage.getItem("fund_code") || "[]");
  const loggedInUser = JSON.parse(sessionStorage.getItem("loggedInUser") || "");

  const [Loading, setLoading] = useState(false);

  const [allFunds, setAllFunds] = useState<any>([]);
  const [allLedgers, setAllLedgers] = useState<any>([]);
  const [allBanks, setAllBanks] = useState<any>([]);
  const [fund, setFund] = useState("");
  const [fundCheck, setFundCheck] = useState(false);
  const [bank, setBank] = useState("");
  const [bankName, setBankName] = useState<any>("");
  const [profit, setProfit] = useState<any>(0.0);

  const [bankCheck, setBankCheck] = useState(false);
  const [accFundLoading, setAccFundLoading] = useState<any>(false);
  const flag = sessionStorage.getItem("rejectedFlag") || false;

  let [paginationArr, setPaginationArr] = useState([""]);
  const [pageSize, setPageSize] = useState("10");

  const [bankLoading, setBankLoading] = useState<any>(false);
  const [ledgerAccounts, setLegderAccounts] = useState<any>([]);

  let [tableData, setTableData] = useState<any>([]);
  let [managementTableData, setManagementTableData] = useState<any>([]);

  const [tableLoading, setTableLoading] = useState<any>(false);
  const [sendingData, setSendingData] = useState<any>([]);
  const [disableProfit, setDisableProfit] = useState<any>(false);
  const [profitRateConfirmed, setProfitRateConfirmed] = useState<any>(false);
  const [bankBalanceData, setBankBalanceData] = useState<any>(false);
  const [totalBalance, setTotalBalance] = useState<any>(0);
  let today: any = new Date();
  let dd = String(today.getDate()).padStart(2, "0");
  let mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
  let yyyy = today.getFullYear();

  today = yyyy + "-" + mm + "-" + dd;
  const [date, setDate] = useState<any>(today);
  const [settlementDate, setSettlementDate] = useState<any>(
    moment(today, "YYYY-MM-DD").add(1, "days").format("YYYY-MM-DD")
  );
  let [sendingLedgers, setSendingLedgers] = useState<any>([]);
  const [headLabel, setHeadLabel] = useState<any>("");
  const [deleting, setDeleting] = useState<any>(false);
  const [netAssets, setNetAssets] = useState<any>("");
  const [trusteeFeeLedgers, setTrusteeFeeLedgers] = useState<any>([]);
  const [trusteeSpecificLedger, setTrusteeSpecificLedger] = useState<any>([]);
  const [trusteeTaxLedger, setTrusteeTaxLedger] = useState<any>([]);

  const [managementSpecificLedgerDebit, setManagementSpecificLedgerDebit] =
    useState<any>([]);
  const [managementSpecificLedgerCredit, setManagementSpecificLedgerCredit] =
    useState<any>([]);
  const [managementTaxLedgerDebit, setManagementTaxLedgerDebit] = useState<any>(
    []
  );
  const [managementTaxLedgerCredit, setManagementTaxLedgerCredit] =
    useState<any>([]);

  const [
    accountingOperationalSpecificLedgerDebit,
    setAccountingOperationalSpecificLedgerDebit,
  ] = useState<any>([]);
  const [
    accountingOperationalSpecificLedgerCredit,
    setAccountingOperationalSpecificLedgerCredit,
  ] = useState<any>([]);

  const [accountingOperationalTableData, setAccountingOperationalTableData] =
    useState<any>([]);

  const [trusteeFee, setTrusteeFee] = useState<any>("");
  let [trusteeFeeTax, setTrusteeFeeTax] = useState<any>(0.0);

  const [managementFee, setManagementFee] = useState<any>("");
  let [managementFeeTax, setManagementFeeTax] = useState<any>(0.0);

  const [accountingOperationalFee, setAccountingOperationalFee] =
    useState<any>("");

  let [taxRate, setTaxRate] = useState<any>(0.0);
  let [managementTaxRate, setManagementTaxRate] = useState<any>(0.0);

  let [secpFee, setSecpFee] = useState<any>(0);
  const [secpLedgerDebit, setSecpLedgerDebit] = useState<any>([]);
  const [secpLedgerCredit, setSecpLedgerCredit] = useState<any>([]);
  const [secpTableData, setSecpTableData] = useState<any>([]);

  const [fields, setFields] = useState<FieldValues>({
    email: email,
    txnr_type: "managementfeeaccrual",
    amc_code: loggedInUser.amc_code,
    dividend_date: "",
    dividend_rate: "",
    fund_code: "",
    reinvest: "false",
    instruction_date: moment(date).format("YYYY-MM-DD"),
    execution_date: moment(date).format("YYYY-MM-DD"),
    executed_date: moment(date).format("YYYY-MM-DD"),
    fund_account: "",
    account_title: "",
    account_no: "",
    bank: "",
    branch: "",
    counter_account_type: "",
    counter_type: "",
    counter_account_title: "",
    counter_account_number: "",
    counter_bank: "",
    counter_branch: "",
    mode_of_payment: "",
    payment_type: "",
    instrument_no: "",
    instrument_type: "",
    instrument_date: moment(date).format("YYYY-MM-DD"),
    // realized_date: moment(date).format('YYYY-MM-DD'),
    realized_date: moment(date).format("YYYY-MM-DD"),
    realized: "true",
    gross_amount: "",
    net_amount: "",
    dr_amount: "",
    period: sessionStorage.getItem("active_period") || "",
    cr_amount: "",
    balance: "",
    folio_no: "",
    unitholder_name: "",
    units: "",
    nav: "",
    sale_date: moment(date).format("YYYY-MM-DD"),
    current_holding: "0",
    total_holding: "",
    symbol: "",
    dividend_percentage: "",
    credit_date: "",
    maturity_type: "",
    security_type: "",
    issue_date: moment(date).format("YYYY-MM-DD"),
    conversion_date: moment(date).format("YYYY-MM-DD"),
    associated_transaction: "",
    maturity_date: moment(date).format("YYYY-MM-DD"),
    coupon_rate: "",
    price: "",
    face_value: 0,
    money_market_face_value: "",
    detail: "",
    type: "",
    redemption_date: moment(date).format("YYYY-MM-DD"),
    remain_holding: "0",
    settlement_by: "",
    tax_type: "",
    settlement_date: moment(settlementDate).format("YYYY-MM-DD"),
    total_charges: "0",
    txn_charges: "",
    sale_txn_no: "",
    return_date: "",
    txn_id: "",
    last_coupon_date: moment(date).format("YYYY-MM-DD"),
    next_coupon_date: moment(date).format("YYYY-MM-DD"),
    yield: "",
    tenor: "",
    fund_ips_account: "",
    counter_party_ips_account: "",
    system_tax: "",
    primary_dealer: "",
    broker_commission: "",
    tax_sst: "",
    tax_wht_it: "",
    tax_wht_sst: "",
    tax_cgt: "0",
    sale_load: "",
    redemption_load: "0",
    low_balance_agree: "",
    offer_price: "",
    load_per_unit: "",
    percentage_of_discount: "0",
    applicable_offer_price: "",
    sales_tax_collector: "SRB", // default value SRB
    volume: "",
    par_value: "",
    announcement_date: "", // Dividend on Investment
    bonus_percentage: "",
    bonus_credit_date: "",
    bonus_gross_volume: "",
    tax_it_bonus_amount: "",
    net_bonus_volume: "",
    right_share_percentage: "",
    right_share_credit_date: "",
    right_share_gross_volume: "",
    tax_it_right_share_amount: "",
    net_right_share_volume: "",
    tax_on_dvidend: "",
    tax_on_bonus: "",
    tax_on_right: "",
    zakat_amount: "0",
    ledgers: "",
  });

  useEffect(() => {
    setLoading(true);
    const getFundByAMcCode = async (code: string) => {
      setAccFundLoading(true);
      allFunds.length = 0;
      setAllFunds(allFunds);

      //get funds by amc for dropdown
      try {
        const response = await getFundByAmc(
          email,
          code,
          fund_code?.length > 0 ? fund_code : ""
        );
        // sort data
        let sortedData: any = [];
        sortedData = response.data.data.sort(function (a, b) {
          let x = a.nature.toLowerCase();
          let y = b.nature.toLowerCase();
          if (x > y) {
            return 1;
          }
          if (x < y) {
            return -1;
          }
          return 0;
        });
        // setAllFunds(response.data.data);
        setAllFunds(sortedData);
        if (response.data.data.length < 1) {
          setFundCheck(true);
        } else {
          setFundCheck(false);
        }
        setLoading(false);

        setAccFundLoading(false);
      } catch (error) {
        console.log("ERROR => ", error);
      }
    };

    getFundByAMcCode(amc_code);
  }, []);

  const getBankAccounts = async () => {
    try {
      const response = await getNewChartsOfAccountsByFund(
        email,
        sessionStorage.getItem("amc_code") || "",
        fund
      );
      if (response.data.status == 200) {
        let ledgersacc = getLedgerAccounts(
          response.data.data.main_family[3].family[0].sub_family
        );
        let ledgersacc2 = getLedgerAccounts(
          response.data.data.main_family[2].family[1].sub_family
        );

        setManagementSpecificLedgerDebit(
          ledgersacc.find((item) => {
            return item.code === 401010101;
          })
        );

        setManagementSpecificLedgerCredit(
          ledgersacc2.find((item) => {
            return item.code === 301020101;
          })
        );

        setManagementTaxLedgerDebit(
          ledgersacc.find((item) => {
            return item.code === 401010102;
          })
        );

        setManagementTaxLedgerCredit(
          ledgersacc2.find((item) => {
            return item.code === 30102010101;
          })
        );

        setLegderAccounts(ledgersacc);

        let allLedgers = await getAllLedgers(response.data.data.main_family);
        setAllLedgers(allLedgers);
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      console.log("ERROR => ", error);
    }
  };

  useEffect(() => {
    if (fund) {
      getBankAccounts();
    }
  }, [fund]);

  const renderFundsDropdown = () => {
    return allFunds.map((item: any, index: string) => {
      if (item.nature === "Special Managed Account") {
        return {
          value: item.symbol_code,
          label: `${item.fund_name} (${item.symbol_code}) - SMA`,
        };
      } else {
        return {
          value: item.symbol_code,
          label: `${item.fund_name} (${item.symbol_code})`,
        };
      }
    });
  };

  const handleLoadSlabAsset = async () => {
    try {
      setTableData([]);
      setManagementFee(0);
      setManagementFeeTax(0);
      let selectedFund = allFunds.find((item) => item.symbol_code === fund);
      let slabs = JSON.parse(selectedFund.fee_slab || "[]");
      if (!slabs || slabs.length === 0) {
        toast.error("Slab data not found in fund!");
        setLoading(false);
        return;
      }
      setTaxRate(selectedFund?.sst_trustee_percentage);

      const netAssetResponse = await getNavDataForCalculation(
        email,
        sessionStorage.getItem("amc_code") || "",
        fund,
        date
      );

      // let totalCurrentNetAssets =

      if (netAssetResponse.data.status === 404) {
        setLoading(false);
        return toast.error("No net asset value found for selected date!");
      }

      if (netAssetResponse?.data.status !== 200) {
        setLoading(false);
        return toast.error("Error loading net asset data!");
      }

      let managementCalc =
        // (parseFloat(netAssetResponse?.data?.data[0]?.total_net_asset || "0") *
        (parseFloat(
          netAssetResponse?.data?.navData?.net_assets_for_fee_calculation || "0"
        ) *
          (selectedFund?.management_fee_percentage / 100)) /
        365;

      let managementTaxCalc =
        managementCalc * (selectedFund?.sst_on_management_fee_percentage / 100);

      setManagementFee(managementCalc.toFixed(4));
      setManagementTaxRate(selectedFund?.sst_on_management_fee_percentage);
      setManagementFeeTax(managementTaxCalc.toFixed(4));

      setManagementTableData([
        {
          gl_code: managementSpecificLedgerDebit.code,
          gl_name: managementSpecificLedgerDebit.name,
        },
        {
          gl_code: managementSpecificLedgerCredit.code,
          gl_name: managementSpecificLedgerCredit.name,
        },
        {
          gl_code: managementTaxLedgerDebit.code,
          gl_name: managementTaxLedgerDebit.name,
        },
        {
          gl_code: managementTaxLedgerCredit.code,
          gl_name: managementTaxLedgerCredit.name,
        },
      ]);
      setNetAssets(
        netAssetResponse?.data?.navData?.net_assets_for_fee_calculation
      );
      setLoading(false);
    } catch (error: any) {
      console.log("ERROR => ", error);
      toast.error(error.message);
      setTableData([]);
      setLoading(false);
    }
  };

  const handleDailyTrusteeFee = async () => {
    setLoading(true);
    let email = sessionStorage.getItem("email");

    let netAmount = 0;

    if (managementFee) {
      const responseDebit = await getLedgerInfo(
        email,
        managementSpecificLedgerDebit.code,
        fund
      );
      const responseCredit = await getLedgerInfo(
        email,
        managementSpecificLedgerCredit.code,
        fund
      );
      netAmount += +managementFee;

      sendingLedgers.push(
        {
          account_number: "",
          account_title: "",
          amc_code: amc_code,
          balance: "",
          bank_code: "",
          branch: "",
          child_family_code: responseDebit.child_family_code,
          child_family_name: responseDebit.child_family_name,
          counter_account_number: "",
          counter_account_title: "",
          counter_bank: "",
          counter_branch: "",
          created_at: "",
          credit_amount: "0",
          debit_amount: parseFloat(managementFee),
          description: "Management Fee Accrual",
          doc_type: "",
          entered_by: "",
          evidence: "",
          family_code: responseDebit.family_code,
          family_name: responseDebit.family_name,
          fund_code: fund,
          gl_code: responseDebit.gl_code,
          gl_name: responseDebit.gl_name,
          instruction_date: "",
          instrument_by: "",
          instrument_date: "",
          instrument_no: "",
          instrument_type: "",
          main_family_code: responseDebit.main_family_code,
          main_family_name: responseDebit.main_family_name,
          realized: "true",
          realized_by: "",
          realized_date: "",
          sub_family_code: responseDebit.sub_family_code,
          sub_family_name: responseDebit.sub_family_name,
          period: sessionStorage.getItem("active_period") || "",
          paid: false,
        },
        {
          account_number: "",
          account_title: "",
          amc_code: amc_code,
          balance: "",
          bank_code: "",
          branch: "",
          child_family_code: responseCredit.child_family_code,
          child_family_name: responseCredit.child_family_code,
          counter_account_number: "",
          counter_account_title: "",
          counter_bank: "",
          counter_branch: "",
          created_at: "",
          credit_amount: parseFloat(managementFee).toFixed(4),
          debit_amount: "0",
          description: "Management Fee Accrual",
          doc_type: "",
          entered_by: "",
          evidence: "",
          family_code: responseCredit.family_code,
          family_name: responseCredit.family_name,
          fund_code: fund,
          gl_code: responseCredit.gl_code,
          gl_name: responseCredit.gl_name,
          instruction_date: "",
          instrument_by: "",
          instrument_date: "",
          instrument_no: "",
          instrument_type: "",
          main_family_code: responseCredit.main_family_code,
          main_family_name: responseCredit.main_family_name,
          realized: "true",
          realized_by: "",
          realized_date: "",
          sub_family_code: responseCredit.sub_family_code,
          sub_family_name: responseCredit.sub_family_name,
          period: sessionStorage.getItem("active_period") || "",
          paid: false,
        }
      );
    }

    if (managementFeeTax) {
      const responseDebit = await getLedgerInfo(
        email,
        managementTaxLedgerDebit.code,
        fund
      );
      const responseCredit = await getLedgerInfo(
        email,
        managementTaxLedgerCredit.code,
        fund
      );
      netAmount += +managementFeeTax;

      sendingLedgers.push(
        {
          account_number: "",
          account_title: "",
          amc_code: amc_code,
          balance: "",
          bank_code: "",
          branch: "",
          child_family_code: responseDebit.child_family_code,
          child_family_name: responseDebit.child_family_name,
          counter_account_number: "",
          counter_account_title: "",
          counter_bank: "",
          counter_branch: "",
          created_at: "",
          credit_amount: "0",
          debit_amount: parseFloat(managementFeeTax).toFixed(4),
          description: "Management Fee Tax Accrual",
          doc_type: "",
          entered_by: "",
          evidence: "",
          family_code: responseDebit.family_code,
          family_name: responseDebit.family_name,
          fund_code: fund,
          gl_code: responseDebit.gl_code,
          gl_name: responseDebit.gl_name,
          instruction_date: "",
          instrument_by: "",
          instrument_date: "",
          instrument_no: "",
          instrument_type: "",
          main_family_code: responseDebit.main_family_code,
          main_family_name: responseDebit.main_family_name,
          realized: "true",
          realized_by: "",
          realized_date: "",
          sub_family_code: responseDebit.sub_family_code,
          sub_family_name: responseDebit.sub_family_name,
          period: sessionStorage.getItem("active_period") || "",
        },
        {
          account_number: "",
          account_title: "",
          amc_code: amc_code,
          balance: "",
          bank_code: "",
          branch: "",
          child_family_code: responseCredit.child_family_code,
          child_family_name: responseCredit.child_family_code,
          counter_account_number: "",
          counter_account_title: "",
          counter_bank: "",
          counter_branch: "",
          created_at: "",
          credit_amount: parseFloat(managementFeeTax).toFixed(4),
          debit_amount: "0",
          description: "Management Fee Tax Accrual",
          doc_type: "",
          entered_by: "",
          evidence: "",
          family_code: responseCredit.family_code,
          family_name: responseCredit.family_name,
          fund_code: fund,
          gl_code: responseCredit.gl_code,
          gl_name: responseCredit.gl_name,
          instruction_date: "",
          instrument_by: "",
          instrument_date: "",
          instrument_no: "",
          instrument_type: "",
          main_family_code: responseCredit.main_family_code,
          main_family_name: responseCredit.main_family_name,
          realized: "true",
          realized_by: "",
          realized_date: "",
          sub_family_code: responseCredit.sub_family_code,
          sub_family_name: responseCredit.sub_family_name,
          period: sessionStorage.getItem("active_period") || "",
        }
      );
    }

    if (sendingLedgers.length > 0) {
      fields.ledgers = JSON.stringify(sendingLedgers);
      fields.fund_code = fund;
      fields.net_amount = netAmount.toString();
      fields.payment_type = "Payment";

      fields.instruction_date = moment(date).format("YYYY-MM-DD");
      fields.execution_date = moment(date).format("YYYY-MM-DD");
      fields.executed_date = moment(date).format("YYYY-MM-DD");
      fields.instrument_date = moment(date).format("YYYY-MM-DD");
      fields.realized_date = moment(date).format("YYYY-MM-DD");
      fields.sale_date = moment(date).format("YYYY-MM-DD");
      fields.issue_date = moment(date).format("YYYY-MM-DD");
      fields.conversion_date = moment(date).format("YYYY-MM-DD");
      fields.maturity_date = moment(date).format("YYYY-MM-DD");
      fields.redemption_date = moment(date).format("YYYY-MM-DD");
      fields.settlement_date = moment(settlementDate).format("YYYY-MM-DD");
      fields.last_coupon_date = moment(date).format("YYYY-MM-DD");
      fields.next_coupon_date = moment(date).format("YYYY-MM-DD");

      if (fields.ledgers.length > 1) {
        try {
          const result = await addMegaTransaction(fields);

          if (result.data.status === 400) {
            toast.warning(result.data.message);
            setSendingLedgers([]);
          } else if (result.data.status === 417) {
            toast.warning(result.data.message);
            setSendingLedgers([]);
          } else {
            toast.success(`Transaction added. ID: ${result.data.txn_id}`);
            setSendingLedgers([]);

            setTimeout(() => {
              history.goBack();
            }, 1000);
          }
        } catch (error) {
          console.log("ERROR => ", error);
          setLoading(false);
        }
      }
    } else {
      toast.error("Not txn data!");
      setLoading(false);
      return;
    }

    setProfitRateConfirmed(true);
  };

  const getLedgerInfo = async (email, ledger_code, fund_code) => {
    const result = await getLedgerInfoByCode(email, ledger_code, fund_code);
    return result.data.data;
  };

  const handleManagementTaxChange = () => {
    //calculation in let, value in set

    let manFeeTax =
      parseFloat(managementFee) * (parseFloat(managementTaxRate) / 100);
    setManagementFeeTax(manFeeTax.toFixed(4));
  };

  useEffect(() => {
    if (managementFee && managementTaxRate) {
      handleManagementTaxChange();
    } else {
      setManagementFeeTax(0);
    }
  }, [managementTaxRate, managementFee]);

  const selectedFundName = React.useMemo(() => {
    const selectedFund = allFunds.find((item) => item?.symbol_code === fund);
    return selectedFund && selectedFund.nature === "Special Managed Account"
      ? {
          value: selectedFund.symbol_code,
          label: `${selectedFund.fund_name} (${selectedFund.symbol_code}) - SMA`,
        }
      : selectedFund
      ? {
          value: selectedFund.symbol_code,
          label: `${selectedFund.fund_name} (${selectedFund.symbol_code})`,
        }
      : null;
  }, [allFunds, fund]);

  const customStyles = {
    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
    option: (styles, { isFocused, isSelected }) => ({
      ...styles,
      background: isFocused
        ? "hsla(291, 64%, 42%, 0.5)"
        : isSelected
        ? "hsla(291, 64%, 42%, 1)"
        : undefined,
      zIndex: 1,
    }),
    menuList: (styles) => ({
      ...styles,
      background: theme == "dark" ? "#3b3b3b" : "#ffffff",
      color: theme == "dark" ? "white" : "",
    }),
    menu: (base) => ({
      ...base,
      zIndex: 100,
    }),
    control: (base, state) => ({
      ...base,
      background: theme == "dark" ? "#25273a" : "#f2f2f2",
      borderRadius: "0.4285rem",
      borderColor: state.isFocused
        ? "#1d8cf8"
        : theme !== "light"
        ? "#2b3553"
        : "",
      boxShadow: state.isFocused ? null : null,
      "&:hover": {
        borderColor: state.isFocused ? "" : "#ba54f5",
      },
      '& .react-select__input input[type="color"]': {
        color: theme === "dark" ? "red" : "black",
      },
    }),
    singleValue: (provided) => ({
      ...provided,
      color: theme == "dark" ? "white" : "black",
    }),
    input: (base) => ({
      ...base,
      color: theme == "dark" ? "white" : "black",
    }),
  };

  return (
    <>
      <ToastContainer limit={1} />
      <div className="content">
        <Row>
          <Col md="12">
            <Container fluid>
              <div className="input-holder">
                <div className="row">
                  <h4 className=" card-title">
                    <i
                      className="fa fa-angle-left mr-2 ml-3 mt-1 pointer"
                      onClick={() => {
                        // history.replace("/admin/create-transaction");
                        //history.replace(`/admin/transactions-accounts`);
                        history.goBack();
                      }}
                    ></i>
                    {/* Daily Trustee Fee */}
                    Management Fee Accrual
                  </h4>
                </div>
              </div>
              <Row>
                <Col md="4">
                  <div className="card">
                    <div className="card-header">
                      <h4 className="card-title">Fund Details</h4>
                    </div>
                    <div className="card-body">
                      <div className="form-group" data-tip="Select Fund">
                        Fund Name*
                        <ReactTooltip
                          textColor="white"
                          backgroundColor="black"
                          effect="float"
                        />
                        {accFundLoading ? (
                          <div className="form-control w-100">
                            <i className="fa fa-spinner fa-spin fa-1x"></i>
                          </div>
                        ) : (
                          <Select
                            disabled={false}
                            value={selectedFundName}
                            label={fundCheck ? "No Fund Found" : "Select Fund"}
                            onChange={(e) => {
                              setLoading(true);
                              setTableData([]);
                              setManagementTableData([]);
                              setSecpTableData([]);
                              setAccountingOperationalTableData([]);
                              setFund(e?.value);
                              setLoading(false);
                            }}
                            menuPortalTarget={document.body}
                            menuShouldBlockScroll={true}
                            isClearable={true}
                            isSearchable={true}
                            name="color"
                            options={renderFundsDropdown()}
                            styles={customStyles}
                          />
                        )}
                      </div>

                      <div className="form-group" data-tip="Select Date">
                        {/* Select NAV Date */}
                        Select Net Assets Date
                        <ReactTooltip
                          textColor="white"
                          backgroundColor="black"
                          effect="float"
                        />
                        {accFundLoading ? (
                          <div className="form-control w-100">
                            <i className="fa fa-spinner fa-spin fa-1x"></i>
                          </div>
                        ) : (
                          <input
                            id="input_Data"
                            className="form-control input_date"
                            type="date"
                            value={date}
                            defaultValue={date}
                            onChange={(e) => {
                              setLoading(true);
                              setTableData([]);
                              setDate(e.target.value);
                              setSettlementDate(e.target.value);

                              setLoading(false);
                            }}
                            disabled={!fund}
                          />
                        )}
                      </div>

                      <div className="form-group">
                        Current Net Assets
                        {accFundLoading ? (
                          <div className="form-control w-100">
                            <i className="fa fa-spinner fa-spin fa-1x"></i>
                          </div>
                        ) : (
                          <input
                            type="text"
                            readOnly
                            value={numberWithCommas(
                              netAssets ? netAssets?.toFixed(4) : 0
                            )}
                            className="form-control text-right"
                          />
                        )}
                      </div>

                      <Row>
                        <div className="col-md-6">
                          <button
                            className="btn btn-default"
                            disabled={Boolean(Loading) || !fund || !date}
                            onClick={() => {
                              setLoading(true);
                              handleLoadSlabAsset();
                            }}
                          >
                            {Loading ? (
                              <>
                                <span
                                  className="spinner-border login-txt spinner-border-sm"
                                  role="status"
                                  aria-hidden="true"
                                ></span>
                                <span className="login-txt"> Loading...</span>
                              </>
                            ) : (
                              <span>Load</span>
                            )}
                          </button>
                        </div>
                      </Row>
                    </div>
                  </div>
                </Col>

                <Col md="4">
                  <div className="card">
                    <div className="card-header">
                      <h4 className="card-title">Management Fee Details</h4>
                    </div>
                    <div className="card-body">
                      <>
                        <div className="form-group ">
                          Management Fee
                          <input
                            type="text"
                            readOnly
                            value={numberWithCommas(
                              parseFloat(managementFee).toFixed(4)
                            )}
                            className="form-control text-right"
                          />
                        </div>

                        <div className="form-group ">
                          Management Fee Tax Rate
                          <NumberFormat
                            thousandSeparator={true}
                            inputMode="numeric"
                            isAllowed={(values) => {
                              const { value } = values;
                              let returnVal;
                              if ((+value < 100 && +value > 0) || value == "") {
                                returnVal = true;
                              } else {
                                returnVal = false;
                              }
                              return returnVal;
                            }}
                            decimalScale={4}
                            value={managementTaxRate}
                            className="form-control text-right"
                            disabled={disableProfit}
                            onChange={(e) => {
                              let inputVal = e.target.value?.replaceAll(
                                ",",
                                ""
                              );
                              if (inputVal.length > 7) {
                                return;
                              }
                              if (parseFloat(inputVal) > 100.0) {
                                return;
                              }
                              if (parseFloat(inputVal) < 0.0) {
                                return;
                              }
                              let rate = parseFloat(inputVal);
                              setManagementTaxRate(rate.toFixed(4));
                              // handleTaxChange();
                            }}
                          />
                        </div>

                        <div className="form-group ">
                          Management Fee Tax
                          <input
                            type="text"
                            readOnly
                            value={numberWithCommas(
                              managementFeeTax
                                ? parseFloat(managementFeeTax).toFixed(4)
                                : 0
                            )}
                            className="form-control text-right"
                          />
                        </div>
                      </>
                    </div>
                  </div>
                </Col>
              </Row>

              {Loading ? (
                <Row>
                  <Col>
                    <div className="d-flex justify-content-center my-5">
                      <i
                        className="fa fa-spinner fa-spin fa-3x"
                        aria-hidden="true"
                      ></i>
                    </div>
                  </Col>
                </Row>
              ) : managementTableData && managementTableData.length > 0 ? (
                <Row>
                  <Col>
                    <div className="card">
                      <div className="card-header">
                        <h4 className="card-title text-primary">
                          Affected Ledgers
                        </h4>
                      </div>
                      <div className="card-body">
                        <div className="table-responsive">
                          <table className="table">
                            <thead>
                              <tr>
                                <th>Code</th>
                                <th>Name</th>
                                <th className="text-center">Debit Amount</th>
                                <th className="text-center">Credit Amount</th>
                              </tr>
                            </thead>
                            <tbody>
                              {managementTableData.map((data, index) => {
                                return (
                                  <tr
                                    key={index}
                                    style={
                                      deleting
                                        ? {
                                            background:
                                              theme == "light"
                                                ? ""
                                                : "rgba(76,88,119,0.1)",
                                          }
                                        : {
                                            background:
                                              theme == "light"
                                                ? ""
                                                : "rgba(37,41,61,1)",
                                          }
                                    }
                                  >
                                    <td>{data.gl_code}</td>
                                    <td>{data.gl_name}</td>
                                    <td className="text-center">
                                      {String(data.gl_code)[0] === "4"
                                        ? !data.gl_name.includes("SST")
                                          ? numberWithCommas(
                                              Number(
                                                managementFee || 0
                                              ).toFixed(4)
                                            )
                                          : numberWithCommas(
                                              Number(
                                                managementFeeTax || 0
                                              ).toFixed(4)
                                            )
                                        : 0.0}
                                    </td>
                                    <td className="text-center">
                                      {String(data.gl_code)[0] === "3"
                                        ? data.gl_name.includes("SST")
                                          ? numberWithCommas(
                                              Number(
                                                managementFeeTax || 0
                                              ).toFixed(4)
                                            )
                                          : numberWithCommas(
                                              Number(
                                                managementFee || 0
                                              ).toFixed(4)
                                            )
                                        : 0.0}
                                    </td>
                                  </tr>
                                );
                              })}
                            </tbody>
                          </table>
                        </div>
                        <div className="row">
                          <div className="col-md-6">
                            <button
                              className="btn btn-primary"
                              disabled={Boolean(Loading)}
                              onClick={() => handleDailyTrusteeFee()}
                            >
                              {Loading ? (
                                <>
                                  <span
                                    className="spinner-border login-txt spinner-border-sm"
                                    role="status"
                                    aria-hidden="true"
                                  ></span>
                                  <span className="login-txt"> Loading...</span>
                                </>
                              ) : (
                                <span>Save Fees</span>
                              )}
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Col>
                </Row>
              ) : null}
            </Container>
          </Col>
        </Row>
      </div>
    </>
  );
};

export default ManagementFeeAccrual;
